import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ApiWrapper, BaseMessagesOne, Orders, PagingResults } from '../../types/utils';
import { BookmarkTypes } from '../../types/bookmark';

export interface ListFilterSpec {
    query?: string;
    page?: number;
    limit?: number;
    orders?: Orders;
}

export class JBookmarkApi extends JBaseApi {
    public getFormattedList<T extends keyof BookmarkTypes>(filterSpecs: ListFilterSpec, format: T) {
        return this.network.post<PagingResults<BookmarkTypes[typeof format]>>({
            o: 'objectList',
            f: 'bookmarksList',
            format: format,
            ...filterSpecs,
        } as OF);
    }

    public addFormattedLink<T extends keyof BookmarkTypes>(targetId: number, targetType: string, format: T) {
        const requestedFormat = format ?? 'list';
        return this.network.post<BookmarkTypes[T]>({
            o: 'custom',
            f: 'actionAdd',
            type: 'bookmarkLink',
            targetId,
            targetType,
            format: requestedFormat,
        } as OF);
    }

    public addBookmark(
        bookmark: Pick<BookmarkTypes[keyof BookmarkTypes], 'bookmarkLabel' | 'bookmarkMeta' | 'bookmarkUrl'>,
        format?: keyof BookmarkTypes,
    ) {
        const requestedFormat = format ?? 'list';
        return this.network.postCSRF<BookmarkTypes[typeof requestedFormat], BaseMessagesOne>({
            o: 'bookmarks',
            f: 'add',
            ...bookmark,
        } as OF);
    }

    public delete(bookmarkId: number): Promise<ApiWrapper<null, BaseMessagesOne>> {
        return this.network.postCSRF<null, BaseMessagesOne>({
            o: 'bookmarks',
            f: 'delete',
            bookmarkID: bookmarkId,
        } as OF);
    }

    public rename(
        bookmarkID: number,
        bookmarkLabel: string,
        bookmarkUrl?: string,
    ): Promise<ApiWrapper<null, BaseMessagesOne>> {
        return this.network.postCSRF<null, BaseMessagesOne>({
            o: 'bookmarks',
            f: 'rename',
            bookmarkID,
            bookmarkLabel,
            bookmarkUrl,
        } as OF);
    }

    public move(
        bookmarkID: number,
        bookmarkReference: number,
        position: 'before' | 'after',
    ): Promise<ApiWrapper<null, BaseMessagesOne>> {
        return this.network.postCSRF<null, BaseMessagesOne>({
            o: 'bookmarks',
            f: 'move',
            bookmarkID,
            bookmarkReference,
            bookmarkPosition: position,
        } as OF);
    }
}
